import { render, staticRenderFns } from "./mark-invoice-to-paid-button.vue?vue&type=template&id=20d7969c&scoped=true"
import script from "./mark-invoice-to-paid-button.vue?vue&type=script&lang=js"
export * from "./mark-invoice-to-paid-button.vue?vue&type=script&lang=js"
import style0 from "./mark-invoice-to-paid-button.vue?vue&type=style&index=0&id=20d7969c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d7969c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/samuelscn/Área de Trabalho/veins/veins-api/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d7969c')) {
      api.createRecord('20d7969c', component.options)
    } else {
      api.reload('20d7969c', component.options)
    }
    module.hot.accept("./mark-invoice-to-paid-button.vue?vue&type=template&id=20d7969c&scoped=true", function () {
      api.rerender('20d7969c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/invoice/components/buttons/mark-invoice-to-paid-button.vue"
export default component.exports